'use strict';
(function (angular) {
	angular.module('PinMeTo.UI').component('pmtSpinner', {
		templateUrl: 'pmtShared/pmtUi/Spinner.html'
	});
})(window.angular);
